import { useEffect } from 'react'

export function usePerformance() {
  useEffect(() => {
    // --- 1. Register Service Worker for caching static assets ---
    if ('serviceWorker' in navigator) {
      // Use a simple cache-first strategy via Cache API
      registerCaching()
    }

    // --- 2. Preload below-fold images after initial paint ---
    const prefetchTimer = setTimeout(() => {
      const imagesToPrefetch = [
        'https://i.postimg.cc/9MBfVQ1x/libro-principal.webp',
        'https://i.postimg.cc/FRmCJJBj/escritor.webp',
        'https://i.postimg.cc/zfZDggQJ/libro-bono-1.webp',
        'https://i.postimg.cc/90nCFR9p/libro-bono-2.webp',
        'https://i.postimg.cc/mDdG8z8K/libro-bono-3.webp',
      ]

      imagesToPrefetch.forEach((src) => {
        const link = document.createElement('link')
        link.rel = 'prefetch'
        link.as = 'image'
        link.href = src
        document.head.appendChild(link)
      })
    }, 3000) // Wait 3s after load to prefetch

    return () => clearTimeout(prefetchTimer)
  }, [])
}

async function registerCaching() {
  try {
    // Use Cache API directly for simple asset caching
    const CACHE_NAME = 'sos-reflujo-v1'
    const cache = await caches.open(CACHE_NAME)

    // Cache font stylesheets on first load
    const fontUrl =
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Playfair+Display:wght@700;800;900&display=swap'

    const cached = await cache.match(fontUrl)
    if (!cached) {
      try {
        const response = await fetch(fontUrl, { mode: 'cors' })
        if (response.ok) {
          await cache.put(fontUrl, response)
        }
      } catch {
        // Silently fail — fonts will load normally
      }
    }
  } catch {
    // Cache API not available — no-op
  }
}
